import {
    SET_ACTIVE_SERVICE_FILTERS,
    SET_AVAILABLE_SERVICE_FILTERS,
    SET_IS_LOADING_SERVICES,
    SET_SERVICES,
    SET_SERVICES_DEFAULTS,
    SET_SERVICES_API_ERROR,
    SET_SERVICE_QUERY,
} from '../../mutation-types';
import Vue from 'vue';

export default {
    [SET_IS_LOADING_SERVICES](state, { isLoading }) {
        state.isLoading = isLoading;
    },
    [SET_SERVICES_DEFAULTS](state, { items, filters }) {
        const { products, skills, topics } = items;

        state.listItems = products;
        state.activeFilters = filters || {};
        state.skills = skills;
        state.topics = topics;
        state.tag = null;
        state.pagination = null;

        state.isInitial = true;
    },
    [SET_SERVICES](state, { items, tag, pagination, filters }) {
        state.listItems = items;
        state.skills = [];
        state.tag = tag;
        state.pagination = pagination;
        state.activeFilters = filters || {};

        state.isInitial = false;
    },
    [SET_AVAILABLE_SERVICE_FILTERS](state, { filters }) {
        state.availableFilters = filters;
    },
    [SET_SERVICES_API_ERROR](state, { error }) {
        state.apiError = error;
    },
    [SET_ACTIVE_SERVICE_FILTERS](state, { filters }) {
        state.activeFilters = filters;
    },
    [SET_SERVICE_QUERY](state, { query }) {
        if (state.activeFilters) {
            Vue.set(state.activeFilters, 'query', query);
        }
    },
};
